import { useEffect, useState } from 'react';
import PageBodyWrapper from '../../components/PageBodyWrapper'
import { GraphQLPagination, StatusBar } from '../../components/common';
import { useSearchParams } from 'react-router-dom';
import useApi from '../../api';
import StockFilter from '../../components/stocks/StockFilter';
import { getQueryVariables } from '../../utils';
import ExchangeRateTable from '../../components/exchangerate/exchangeRateTable';
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client";
import ExchangeRateForm from '../../components/exchangerate/exchangeRateForm';

const GET_ALL_EXCHANGE_RATE = gql`
  query GetExchangeRates(
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    currencyExchanges(
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      edges {
        node {
          dbId
          baseCurrency
          exchangeRate
          targetCurrency
          createdAt
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

function ExchangeRate() {
  const [stocks, setStocks] = useState<any>()
  const [isOpenStockCreateForm, setIsOpenStockCreateForm] = useState<boolean>(false)
  const [isOpenStockFilter, setISOpenStockFilter] = useState<boolean>(false)
  const [searchParams, setSearchParams] = useSearchParams();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const currentStatus = searchParams.get("status");
  
  const api = useApi()
  
  const [filterData, setFilterData] =  useState<any>({});

  const { data, loading, error, refetch } = useQuery(GET_ALL_EXCHANGE_RATE, {
    variables: getQueryVariables(searchParams),
    notifyOnNetworkStatusChange: true,
  });

  const changeStatus = (status: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("status", status);
    newParams.set("page", "1"); 
    setSearchParams(newParams);
  };

  const toggleStockCreateForm = () => {
    setIsOpenStockCreateForm(!isOpenStockCreateForm)
  }


  useEffect(() => {
    if (!searchParams.get("first") && !searchParams.get("last")) {
      setSearchParams({ first: "20" });
    }
  }, []);


  const fetchExchangeRates = () => {
    refetch();
  }


  return (
    <PageBodyWrapper>
      
      <StatusBar
        onButtonClick={() => setOpenModal(!openModal)}
        statusList={[]}
        buttonLabel="Add Exchange Rate"
        fieldName="status"
      />

      {isOpenStockFilter && <StockFilter isOpen={isOpenStockFilter} onClose={()=>setIsOpenStockCreateForm(!isOpenStockFilter)}/>}

      <ExchangeRateTable data={data?.currencyExchanges?.edges || []} refresh={fetchExchangeRates}/>

      <GraphQLPagination 
        edges={data?.currencyExchanges?.edges || []}
        pageInfo={data?.currencyExchanges?.pageInfo || {}}
      />


      {openModal && <ExchangeRateForm refresh={refetch}  isOpen={openModal} onClose={()=>setOpenModal(!openModal)}/>}
      
    </PageBodyWrapper>
  )
}

export default ExchangeRate